module.exports = __webpack_public_path__ + "f813f6ee5f4d6529a4c8a2594aab7289.svg";